import { Folder } from "../../redux/interfaces/folder.types.ts";
import { EyeIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "antd";
import React from "react";
import { folderExceptions } from "../../exceptions/default/folderExceptions.ts";

interface PreviewMultireportWeb {
  folder: Folder;
  isAdminOrOps: boolean;
  subFoldersAreReady: boolean;
  isCjaUser: boolean | undefined;
  isAssistantUser: boolean | undefined;
  isIconViewValidated: boolean | undefined;
}

export const PreviewMultireportWeb: React.FC<PreviewMultireportWeb> = ({
  folder,
  isAdminOrOps,
  subFoldersAreReady,
  isIconViewValidated,
  isCjaUser,
  isAssistantUser,
}) => {
  const tooltipTitle = (() => {
    // CJA user needs complete file delivery
    if (isCjaUser && !folder.is_multireport_delivered) {
      return folderExceptions.completeFileFolder;
    }
    // Non-CJA users need proper permissions and folder readiness
    if (!isCjaUser) {
      if (!isAdminOrOps && !isAssistantUser)
        return folderExceptions.isNotAdminOrOps;
      if (!subFoldersAreReady) return folderExceptions.subfoldersAreNotReady;
      if (!folder.analysis) return folderExceptions.folderAnalysis;
    }
    return "Previsualizar reporte de inquilino";
  })();

  const handlePreview = () => {
    // Open the web report in a new tab safely
    const reportUrl = `/folders/${folder.folder_number}/multireport/preview`;
    const newTab = window.open(reportUrl, "_blank", "noopener,noreferrer");
    if (newTab) newTab.opener = null;
  };

  return (
    <div>
      <Tooltip title={tooltipTitle} className="cursor-pointer">
        <EyeIcon
          color="gray"
          className={`h-6 w-6 ${!isIconViewValidated ? "text-green-200" : "text-green-600 hover:text-blue-400"}`}
          onClick={!isIconViewValidated ? undefined : handlePreview}
        />
      </Tooltip>
    </div>
  );
};
